import { Page } from '@/core/architecture'

import { QRcodeGetItemTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * QRcodeGetItem Page
 * Implemented as a practical sample.
 */
export const QRcodeGetItem: Page = () => {
  const { state, actions } = useViewModel()

  return <QRcodeGetItemTemplate state={state} {...actions} />
}
